<div class="apg-panel">

  <div class="summary__buttons">
    <a href="javascript:void(0)" (click)="findExisting.emit()">Retrieve existing quote</a>
  </div>

  <form name="quickQuoteForm" #qqForm="ngForm" class="quick-quote-page" *ngIf="page.type !== 'Static'">

    <div class="title" *ngIf="page.showHeader">{{page.title}}</div>

    <div class="cube">
      <div class="filler">
      </div>

      <div class="questions">
        <div *ngFor="let question of page.questions; index as i" class="question">
          <app-question [question]="question" [showHeader]="page.questions.length &gt; 1 || page.questions.length ===1 "
                        *ngIf="question.visible" [autofocus]="i == 0">
          </app-question>
        </div>

        <app-paging class="app-paging" [page]="page" [valid]="qqForm.form.valid" [firstPage]="firstPage"
                    (showInvalid)="showInvalid()">
        </app-paging>

        <div *ngIf="page.index === 0" class="document-links">
          <app-site-content key="QuickQuoteSummary.DocumentLinks_CI" showTitle="true">
          </app-site-content>
        </div>

      </div>

      <div class="line" *ngIf="!page.comment">
      </div>

      <app-info-block class="comment" [comment]="page.comment" (opened)="opened.next($event)">
      </app-info-block>

    </div>
  </form>
</div>